import { render, staticRenderFns } from "./StockchartMenu.vue?vue&type=template&id=3072fa74&scoped=true&"
import script from "./StockchartMenu.vue?vue&type=script&lang=js&"
export * from "./StockchartMenu.vue?vue&type=script&lang=js&"
import style0 from "./StockchartMenu.vue?vue&type=style&index=0&id=3072fa74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3072fa74",
  null
  
)

export default component.exports